import { Container } from '@/atoms';
import { CardZone, ProductBlock, SliderCard } from '@/molecules';

import { sectionBgProps, textStyleClass } from '@/utils';
import { getRealUrl } from '@/utils/utils';

/**
 * ComponentRevisadasOtrasZonas
 */
export const ComponentRevisadasOtrasZonas = ({
  Titulo,
  Descripcion,
  TituloEstilo,
  DescripcionEstilo,
  zonas,
  Enlace,
  FondoSeccion,
}: any) =>
  zonas?.length > 0 ? (
    <Container wrapper {...sectionBgProps(FondoSeccion)}>
      <ProductBlock
        title={Titulo}
        description={Descripcion}
        titleStyleClass={textStyleClass(TituloEstilo)}
        descriptionStyleClass={textStyleClass(DescripcionEstilo)}
      >
        <SliderCard
          link={{ label: 'Ver todas', href: Enlace }}
          perPage={3}
          breakpoints={{
            1024: {
              perPage: 3,
            },
            768: {
              padding: 38,
              perPage: 2,
              gap: 16,
            },
            500: {
              padding: 30,
              perPage: 1,
            },
          }}
        >
          {zonas.map((itm: any, index: number) => (
            <CardZone
              key={`otras-zonas-${index}`}
              title={`En ${itm.Nombre}`}
              image={{
                src: getRealUrl(itm.Imagen.url),
                alt: itm.Imagen.alternativeText,
              }}
              href={itm.Link}
              className="text-neutrals-900"
            />
          ))}
        </SliderCard>
      </ProductBlock>
    </Container>
  ) : null;

ComponentRevisadasOtrasZonas.displayName = 'ComponentRevisadasOtrasZonas';
